import { ErrorKeys } from 'consts/errorKeys'
import { withAppThunks } from 'store/with-app-thunks'
import { TAppDispatch } from 'store/types'

export const handleApiError = (type: ErrorKeys, message?: string) =>
  withAppThunks(appThunks => (dispatch: TAppDispatch) => {
    dispatch(
      appThunks.editorThunks.setApiErrorPopupData({
        type,
        message
      })
    )
  })
